import EventBus from './eventBus';

export default class Dirs21 {

    constructor() {
        this.init();
    }

    init() {
        EventBus.$on('rooms-list-updated', () => {
            // console.log('rebind Ibe Triggers');
            window.d21_api.ibe.rebindIbeTrigger();
        });
    }

};
